import { schema } from 'normalizr';
import { SCHEMA_TYPE_TEAMS, SCHEMA_TYPE_ORGS } from '../constants/schemaTypes';

const orgSchema = new schema.Entity(SCHEMA_TYPE_ORGS);

const teamSchema = new schema.Entity(SCHEMA_TYPE_TEAMS, {
  org: orgSchema,
});

export default teamSchema;
